import { render, staticRenderFns } from "./FormatoField.vue?vue&type=template&id=70a376bd"
import script from "./FormatoField.vue?vue&type=script&lang=js"
export * from "./FormatoField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports